const state = {
    containerShipmentFields: [
        {
            key: "ord_code",
            label: "訂單單號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "serno",
            label: "項次",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "prod_code",
            label: "品號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "prod_name",
            label: "品名",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "batch",
            label: "批號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "ord_qty",
            label: "訂單數量",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "ord_weight",
            label: "訂單重量(KG)",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "pallet_qty",
            label: "棧板數量",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "process",
            label: "狀態",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
    ],
    containerShipmentItem: {
        finished: [],
        warehousing: [],
        not_warehousing: []
    },
}
const getters = {
    get_containerShipmentFields: state => {
        return state.containerShipmentFields
    },
    get_containerShipmentItem: state => {
        return state.containerShipmentItem
    },
}
const actions = {
    set_containerShipmentFields(context, array) {
        context.commit('SET_CONTAINERSHIPMENTFIELDS', array);
    },
    set_containerShipmentItem(context, array) {
        context.commit('SET_CONTAINERSHIPMENTITEM', array);
    },
    clear_containerShipmentItem(context) {
        context.commit('CLEAR_CONTAINERSHIPMENTITEM');
    },
}
const mutations = {
    SET_CONTAINERSHIPMENTFIELDS(state, array) {
        state.containerShipmentFields = array;
    },
    SET_CONTAINERSHIPMENTITEM(state, array) {
        state.containerShipmentItem = array;
    },
    CLEAR_CONTAINERSHIPMENTITEM(state) {
        state.containerShipmentItem = [];
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/containerShipment.js